import index from "./projectList.vue";
export default index;
